import { render, staticRenderFns } from "./GFLoanForm.vue?vue&type=template&id=5975c826"
import script from "./GFLoanForm.vue?vue&type=script&lang=js"
export * from "./GFLoanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports